'use client';

import React, { createContext, useContext } from 'react';

import { useCategoryMegaMenuData } from '@/hooks/common/useCategoryMegaMenuData';

import { CategoryMegaMenuProviderProps } from './models';

import { CategoryMegaMenuItem } from '@/types/categoryMegaMenu';

type CategoryMegaMenuContextValue = {
    categoryMegaMenuItems: CategoryMegaMenuItem[];
    isCategoryMegaMenuLoaded: boolean;
};

const CategoryMegaMenuContext = createContext<CategoryMegaMenuContextValue>({
    categoryMegaMenuItems: [],
    isCategoryMegaMenuLoaded: false
});

export const CategoryMegaMenuProvider = ({ initialCategories = [], children }: CategoryMegaMenuProviderProps) => {
    const { categoryMegaMenuItems, isCategoryMegaMenuLoaded } = useCategoryMegaMenuData(initialCategories);

    return (
        <CategoryMegaMenuContext.Provider value={{ categoryMegaMenuItems, isCategoryMegaMenuLoaded }}>{children}</CategoryMegaMenuContext.Provider>
    );
};

export const useCategoryMegaMenu = () => useContext(CategoryMegaMenuContext);
